import { axios } from '@/utils/request'

/**
 * 查询recipe
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipePage (parameter) {
  return axios({
    url: '/recipe/page',
    method: 'get',
    params: parameter
  })
}

/**
 * recipe列表
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeList (parameter) {
  return axios({
    url: '/recipe/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加recipe
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeAdd (parameter) {
  return axios({
    url: '/recipe/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑recipe
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeEdit (parameter) {
  return axios({
    url: '/recipe/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除recipe
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeDelete (parameter) {
  return axios({
    url: '/recipe/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出recipe
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeExport (parameter) {
  return axios({
    url: '/recipe/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 查询在线发药详情
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/recipe/detail',
    method: 'get',
    params: parameter
  })
}


/**
 * 填写物流
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeSend (parameter) {
  return axios({
    url: '/recipe/writePackage',
    method: 'post',
    params: parameter
  })
}


/**
 * 确认发药
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeConfirm (parameter) {
  return axios({
    url: '/recipe/sendMedi',
    method: 'post',
    params: parameter
  })
}

/**
 * 自提码校验
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
 export function recipePickupCode (parameter) {
  return axios({
    url: '/recipe/pickUpCodeVerify',
    method: 'get',
    params: parameter
  })
}


/**
 * 获取收货地址
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeGetAddress (parameter) {
  return axios({
    url: '/recipe/getOrderAddr',
    method: 'get',
    params: parameter
  })
}



/**
 * 预约寄件
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function recipeMail (parameter) {
  return axios({
    url: '/recipe/send',
    method: 'post',
    data: parameter
  })
}


/**
 * 取消预约寄件
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function cancelRecipeMail (parameter) {
  return axios({
    url: '/recipe/cancel',
    method: 'post',
    data: parameter
  })
}



/**
 * 取消预约寄件
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function getRecipeOrderAddr (parameter) {
  return axios({
    url: '/recipe/getOrderAddr',
    method: 'get',
    params: parameter
  })
}


/**
 * 获取快递公司
 *
 * @author LIWEI
 * @date 2022-04-07 14:16:06
 */
export function getComSelect (parameter) {
  return axios({
    url: '/recipe/comSelect',
    method: 'post',
    data: parameter
  })
}